export enum InstallmentType {
  CARDS = 'CARDS',
  BANKS = 'BANKS',
  NONE = 'NONE'
}
